import { render, staticRenderFns } from "./EditAgents.vue?vue&type=template&id=12f4174a&"
import script from "./EditAgents.vue?vue&type=script&lang=js&"
export * from "./EditAgents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports